import { lazy } from 'react';

const ArretePublicationDateContainer = lazy(
  () => import('../containers/ArretePublicationDateContainer'),
);

const ArretePublicationDateRoute = () => <ArretePublicationDateContainer />;

export default ArretePublicationDateRoute;
